export default "__VITE_ASSET__DjqfM$ta__"